var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeAreBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 159,
    viewBox: "0 0 263 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2706 10.0924L14.8841 0.305741C10.5609 -1.23919 6.61545 3.3709 8.80955 7.40369L25.405 37.9065C25.9995 38.9992 26.9347 39.7743 28 40.1833V127C28 135.837 35.1635 143 44 143H247C255.837 143 263 135.837 263 127V26C263 17.1634 255.837 10 247 10H44C43.4157 10 42.8387 10.0313 42.2706 10.0924Z",
    fill: "#AFF7CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2696 25.9917L6.70055 11.8516C2.37728 10.3067 -1.56814 14.9168 0.625955 18.9496L17.2214 49.4524C17.4388 49.852 17.7018 50.2091 18 50.5214V143C18 151.837 25.1635 159 34 159H219C227.837 159 235 151.837 235 143V42C235 33.1634 227.837 26 219 26H46.2925C46.2849 25.9972 46.2772 25.9945 46.2696 25.9917Z",
    fill: "#AFF7CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeAreBg);
export default __webpack_public_path__ + "static/media/we_are_bg.b3b58015280ea2d147ecb938b18315a1.svg";
export { ForwardRef as ReactComponent };